<form [formGroup]="bulkTicketForm" novalidate>
  <!-- Dialog Header -->
  <div class="flex items-center justify-center dialog-header">
    Update Bulk Ticket
    <div class="absolute right-2">
      <button (click)="handleCloseDialog()" class="outline-none p-5">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content  space-y-4" style="margin-top: -15px;">
    <!-- Ticket Count -->
    <div class="font-semibold text-base mb-4 mt-4">
      Total Tickets: {{ totalTickets }}
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="field flex flex-col">
        <label class="mb-1 text-sm font-medium text-gray-600">Assigned To</label>
        <p-select appendTo="body" [options]="users" formControlName="assign_to" placeholder="Select Assignee"
          optionLabel="label" optionValue="value" styleClass="w-full">
        </p-select>
      </div>

      <div class="field flex flex-col">
        <label class="mb-1 text-sm font-medium text-gray-600">Ticket Status</label>
        <p-select appendTo="body" [options]="ticketStatusOptions" formControlName="ticket_status"
          placeholder="Select Status" styleClass="w-full">
        </p-select>
        <small *ngIf="bulkTicketForm.get('ticket_status')?.invalid && bulkTicketForm.touched" class="p-error mt-1">
          Ticket status is required
        </small>
      </div>
    </div>

    <!-- Description -->
    <div class="field flex flex-col">
      <label class=" mb-1 text-sm font-medium text-gray-600">Ticket Description</label>
      <textarea pTextarea formControlName="ticket_desc" rows="4" placeholder="Enter description"
        class="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-400">
      </textarea>
      <small *ngIf="bulkTicketForm.get('ticket_desc')?.invalid && bulkTicketForm.touched" class="p-error mt-1">
        Description is required
      </small>
    </div>

    <!-- Source & Priority -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="field flex flex-col">
        <label class=" mb-1 text-sm font-medium text-gray-600">Source</label>
        <p-select appendTo="body" [options]="sourceOptions" formControlName="source" placeholder="Select Source"
          styleClass="w-full">
        </p-select>
        <small *ngIf="bulkTicketForm.get('source')?.invalid && bulkTicketForm.touched" class="p-error mt-1">
          Source is required
        </small>
      </div>

      <div class="field flex flex-col">
        <label class="mb-1 text-sm font-medium text-gray-600">Priority</label>
        <p-select appendTo="body" [options]="priorityOptions" formControlName="priority" placeholder="Select Priority"
          styleClass="w-full">
        </p-select>
        <small *ngIf="bulkTicketForm.get('priority')?.invalid && bulkTicketForm.touched" class="p-error mt-1">
          Priority is required
        </small>
      </div>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end gap-2 mt-8">
      <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()">
      </p-button>

      <p-button label="Submit" icon="pi pi-check" [loading]="btnLoading" [disabled]="btnLoading" (click)="onSubmit()">
      </p-button>
    </div>
  </div>
</form>